import React, { useState, useEffect } from "react";
import ValidatedImage from "../../utils/ValidatedImage"
import LetterOfEmancipationDialog from "./LetterOfEmancipationDialog/LetterOfEmancipationDialog"
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import { useTranslation } from "react-i18next";

function LetterOfEmancipationCard(props){

    const { t } = useTranslation()

    const { letter_of_emancipation } = props

    const [OCR, setOCR] = useState(null)
    const [OCRPictureOpen, setOCRPictureOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (letter_of_emancipation.ocr_key){
                axios.get('/dash/ocr/' + letter_of_emancipation.ocr_key).then( response => {
                    let ocr_data = response.data.processed_object
                    if (ocr_data == null) throw new Error()
                    setOCR(ocr_data);             
                }).catch(error => {
                    setOCR(undefined)
                })
            }
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [letter_of_emancipation])

    let getPictureContent = (picture) => {
        if (picture === undefined) {
            return (          
                <div 
                    className={["labelText", "normalMediumSize"].join(" ")} 
                    style={{textAlign:"center", margin:"auto"}}
                >
                    {t("information_unavailable")}
                </div>
            )
        } 
        else{
            return (
                <ValidatedImage
                    image_key={picture}
                    dash_api_endpoint_url={'/dash/ocr/image'}
                    imageStyle = {{margin:"auto", width:"100%", height:"100%",position:"absolute", top:"-9999px",bottom:"-9999px",left:"-9999px",right:"-9999px", borderRadius: "5px", objectFit:"cover"}}
                    imageAlt = {"Foto do Documento"}
                />
            );
        }
    };

    if (OCR === null) {
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Carta de Emancipação OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (OCR === undefined){
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Carta de Emancipação OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                        {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div style={{minHeight: "600px", width:"100%"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Carta de Emancipação OCR")}</div>
                <div className="internalCardContainer" style={{display:"flex", flexGrow:"1", maxHeight:"600px",flexDirection: "row", width:"100%"}}>
                    <div style={{display:"flex", maxHeight:"64vw", flexDirection: "column", width:"100%"}}>
                        <div style={{display:"block", width:"100%", height:"90%", margin: "0 auto", overflow:"hidden", position:"relative", alignItems: "center", justifyContent: "center",borderRadius: "5px"}}>
                            {letter_of_emancipation.ocr_key && getPictureContent( letter_of_emancipation.ocr_key )}
                        </div>
                        {letter_of_emancipation.ocr_key&&
                        <div 
                            onClick={()=>setOCRPictureOpen(true)}
                            className={["blueText", "normalSmallSize", "link"].join(" ")} 
                            style={{margin:"10px", textAlign:"center"}}
                        >
                        </div>}
                    </div>
                    {letter_of_emancipation.ocr_key&&
                        <LetterOfEmancipationDialog
                            open={OCRPictureOpen}
                            onClose={()=>setOCRPictureOpen(false)}
                            image_list={[letter_of_emancipation.ocr_key]}
                    />}
                </div>
            </div>
        );
    }
}

export default LetterOfEmancipationCard